import React from "react";

const NoDataFound = ({found}) => {
  return (
    <div className="no-record-found text-center mt-md-5 mt-0">
      <i
        className="fa fa-inbox pb-0 no-data-icon"
        style={{ fontSize: "75px", color: "#ccc" }}
      ></i>
      <p className="pt-0" style={{ color: "#313131fc", fontSize: "14px" }}>
       { found ? found : 'No Activity Found'}
      </p>
    </div>
  );
};

export default NoDataFound;
